module.exports = __webpack_public_path__ + "img/no-data.e7ce9496.svg";